import React from 'react';
import ContentLayout from '../core/ContentLayout';

const RouteCalculation = () => {
    return (
        <ContentLayout titleTranslateId='routeCalculation.title'>
        </ContentLayout>
    );
}

export default RouteCalculation;
